export const copyResponseToClipboard = (content: string | object) => {
  navigator.clipboard.writeText(
    typeof content === 'string' ? content : JSON.stringify(content, null, 2),
  );
};
